angular.module('ngApp')
.controller('confirmMailController', ['$scope', '$timeout', 'User', '$rootScope', 'ipCookie', '$stateParams', '$state', function ($scope, $timeout, User, $rootScope, ipCookie, $stateParams, $state) {
  $scope.status = $stateParams.status === 'true' || false
}])
